<template>
    <div>
        <div class="uk-padding">
            <div class="uk-container">
                <h1 class="uk-text-center">College of Business & Management </h1>
                <hr>
                <h2 class="uk-text-left" >
                    Message from the Dean
                    <span class="uk-text-muted uk-text-small uk-text-italic"  style="font-variant: none !important;"> Marjorie Buckley, PHD</span>
                </h2>
                <div class="uk-panel">

                    <img class="uk-border-rounded uk-align-left@m" src="../assets/Marjorie_Buckley_2023.jpg" width="180" height="180" alt="Border pill">

                    <p>
                        Welcome to the website of the College of Business and Management (CBM) at Northern
                        Caribbean University.  The College of Business and Management prides itself in preparing men
                        and women based on Christian principles for positions in businesses and to nurture enterprising
                        students to start their own businesses.   We value honesty, integrity, fairness and balance.  We
                        encourage our students to be caring, creative, bold and innovative.
                    </p>
                    <p>
                        To the prospective employer we offer the complete worker; to the aspiring individual, we offer
                        the way to make your big dreams come true.
                    </p>
                    <p>
                        We are committed and excited about transforming lives that will make a difference in society
                        based on our core values.
                    </p>

                    <p>
                        Sincerely <br>
                      Marjorie Buckley, PHD <br>
                        College of Business & Management
                    </p>
                </div>
            </div>

        </div>
        <cbm-department-links/>
        <div class="uk-padding uk-background-secondary uk-light">
            <div class="uk-container">
                <h2 class="uk-heading-line"><span>A Success Stories</span></h2>
                <div class="uk-panel">
                    <img class="uk-align-left@m uk-margin-remove-adjacent" src="../assets/graduate.jpg"
                         style="max-width: 400px; max-height: 400px; width: auto; height: auto; border-radius: 10px" alt="image">
                    <p>Name: Chad-Anthony Coke </p>
                    <p>
                        NCU and the College of Business &amp; Management congratulates final year student, Mr. Chad-
                        Anthony Coke on winning the Jamaica Stock Exchange (JSE’s) 2019/2020 4 th  quarter Market
                        Research Competition. The analyses was on the Sagicor Real Estate X Fund Limited’s current
                        performance and prospects beyond COVID-19. Chad Anthony Coke was joint winner in the 17 th
                        year of the Competition which commenced in 2003.
                    </p>
                    <p>
                        Mr. Coke’s analysis on the Company SYGNUS CREDIT INVESTMENTS LIMITED included areas such:

                    </p>
                    <ul>
                        <li>The Company’s financial performance/strength for the past three (3) years;</li>
                        <li>COVID-19 and how has it affected Jamaica and the Company;</li>
                        <li>The likely impacts to the Company after COVID-19;</li>
                        <li>Changes in international economic policies that could impact the company;</li>
                        <li>The impact of Investors’ interest on the Company during and after COVID-19;</li>
                        <li>Recommendation to wither buy / hold or sell the Company’s shares.</li>

                    </ul>
                    <p>
                        Mr. Coke career aspirations are geared towards Investment Research & Banking as well as Asset
                        Management and he is passionate about the financial and capital markets, macroeconomics and
                        alternative investments.  Another of his goal is to attain the Chartered Financial Analyst (CFA)
                        and Chartered Alternative Investment Analyst (CAIA).
                    </p>

                </div>
            </div>
        </div>

        <div class="uk-padding uk-background-muted">
            <div class="uk-container uk-container-large">
                <!--<h2 class=" uk-text-bold uk-text-center uk-text-capitalize " style="font-variant: normal !important;">College Highlight
                </h2>-->
                <div class="uk-container">
                    <h2 class="uk-heading-line"><span>The Michael Sutherland Story</span></h2>
                    <div class="uk-panel">
                        <img class="uk-align-left@m uk-margin-remove-adjacent" src="../assets/MS.jpg"
                             style="max-width: 400px; max-height: 400px; width: auto; height: auto; border-radius: 10px" alt="image">
                        <p>Michael Sutherland is a small and medium enterprise business banker at Sagicor Bank. Armed with
                            a Bachelor of Science and a Master of Science degree in business administration, who specialised
                            in finance, at the Northern Caribbean University (NCU), Sutherland has been successful in his
                            professional pursuit for the past two years. Priding himself on being a top performer, he has
                            already achieved the status of team member of the month and for the quarter. </p>
                        <p class="uk-text-bold">
                            Early childhood and education
                        </p>
                        <p>
                            Sutherland grew up as an orphan, knowing nothing of his identity. He spent his baby days at
                            Blossom Gardens, and by the time he was two, he was transferred to what would become his
                            foundation, the SOS Children’s Village in Barry Town, Stony Hill, where he remained until he was 23 years old.

                        </p>
                        <p>
                            Aside from education, Sutherland shared that SOS also believed in discipline. And as far back as he could remember, he always displayed a great level of discipline – he has three consecutive years of winning ‘Child of the Year‘ to prove this. This innate trait, unearthed by the village, set his pathway for success. He was also an all-rounder at SOS, actively playing both tennis and football. Transitioning from Jane Vera, owned by the home, to William Knibb Memorial High School, he was sidetracked by sports, so he attended Montego Bay Community College, where he attained an associate degree in management. NCU became his home away from home for both his bachelors and master’s degree, and even provided tutorial opportunities to the young scholar, who was more than happy to help others.

                        </p>
                        <p>Strategic career moves</p>
                        <p>
                            Sutherland worked with the National Commercial Bank for close to seven years before moving to Sagicor, a switch he deemed as strategic, as he believes in relationship banking and felt this was a better fit for his growth and development. Since then, he has received the Business Banker of the Year for 2017 at the Sagicor Awards and has applied for the leadership programme, where he was successful. But his proudest moment to date: being a motivational speaker to Canadian diplomats and representing SOS in the process.
                        </p>
                        <p>
                            He now stands as a board associate member of the SOS Children’s Village and he’s happy to be paying it forward by providing necessities that weren’t readily available to him during his time at SOS. He has become a beacon of hope to the youth, inspiring them to rise from their circumstances, be their very best, and achieve greatness. So what’s next for this brilliant banker? He would like to pursue his PhD in strategic management, start his own business one day, and write a tell-all book of his life.“I was constantly being teased for being at SOS while I was at school and playing tennis. Because I came from the village, when I went in the public space I was labelled as an outcast, told my mother and father threw me away, ostracised and criticised for being an orphan, and that can be very demotivating and have a negative impact on your personal and emotional life. The struggle was real and sometimes I felt like giving up. So, my advice to anyone going through this: It’s not about where you’re coming from, it’s about where you’re going. To come full circle and to represent my family SOS, internationally, brought me immense joy. Keep your head up, do your best, look out for the opportunities and don’t let them pass you by … you never know what life has in store for you.”

                        </p>
                        <p class="uk-text-muted">krysta.anderson@gleanerjm.com</p>
                        <p class="uk-text-bold">Jamaica Gleaner</p>
                        <!--<a class="uk-float-right" target="_blank" href="http://dolarve.com/el-diario-de-risaralda-roberto-pocaterra-pocaterra-venezuela-pansexual-un-known-identity-the-michael-sutherland-story/">Read More</a>
                    --></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import CbmDepartmentLinks from "../components/colleges/cbm/departmentLinks";
    export default {
        name: "BMH",
        components: {CbmDepartmentLinks}
    }
</script>

<style scoped>

</style>